module.exports = __webpack_public_path__ + "static/media/customer-service.c25e202e.svg";